import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "py-3 container-fluid space-y-4" }
const _hoisted_2 = { class: "bg-white rounded-xl shadow-md p-3" }
const _hoisted_3 = { class: "flex flex-col md:flex-row md:items-center gap-3" }
const _hoisted_4 = { class: "flex items-center gap-3 w-full" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "flex flex-col" }
const _hoisted_7 = { class: "text-xl font-bold mb-1 text-slate-800" }
const _hoisted_8 = { class: "mb-0 text-xs text-slate-500" }
const _hoisted_9 = { class: "mx-auto mt-4 px-4 w-full md:w-1/2 lg:w-1/3 sm:my-auto sm:ml-auto sm:mr-0" }
const _hoisted_10 = { class: "relative w-full text-right" }
const _hoisted_11 = { class: "bg-white rounded-xl shadow-md" }
const _hoisted_12 = { class: "p-3 mb-2 space-y-2" }
const _hoisted_13 = { class: "text-lg font-bold text-slate-800" }
const _hoisted_14 = { class: "text-gray-600 text-sm font-light" }
const _hoisted_15 = { class: "divide-y divide-gray-200 list-none pb-4" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "flex items-center gap-3 py-2 mx-3" }
const _hoisted_18 = { class: "flex-1 text-left" }
const _hoisted_19 = { class: "text-sm md:text-lg font-semibold" }
const _hoisted_20 = { class: "text-sm font-semibold text-gray-700 uppercase" }
const _hoisted_21 = { class: "relative" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_NavPill = _resolveComponent("NavPill")!
  const _component_DetalleAgendaView = _resolveComponent("DetalleAgendaView")!
  const _component_FullScreenLoader = _resolveComponent("FullScreenLoader")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("img", {
              src: _ctx.acreditado && _ctx.acreditado.foto ? _ctx.acreditado.foto : require('@/assets/img/nologo.png'),
              class: "shadow-sm w-16 rounded-lg"
            }, null, 8, _hoisted_5),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("h5", _hoisted_7, _toDisplayString(_ctx.acreditado ? _ctx.acreditado.nombre + " " +
              _ctx.acreditado.apellido : _ctx.$t('label.cargando')), 1),
              _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t('label.fecha.alta')) + " : " + _toDisplayString(_ctx.acreditado ?
              _ctx.formatDate(_ctx.acreditado.fechaAlta, 'dd/MM/yyyy HH:mm:ss') : _ctx.$t('label.cargando')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.downloadAgendaPdf && _ctx.downloadAgendaPdf(...args))),
                class: "px-5 text-sm font-bold text-white py-3 bg-gradient-to-r from-[#424c42] to-[#bbc1a9] shadow-md rounded-xl transform transition-transform duration-200 hover:scale-105 active:scale-95"
              }, [
                _createVNode(_component_font_awesome_icon, {
                  icon: ['faf', 'fa-file-pdf'],
                  class: "mr-2"
                }),
                _createTextVNode(_toDisplayString(_ctx.$t('boton.download.pdf')), 1)
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("h6", _hoisted_13, _toDisplayString(_ctx.$t('menu.agenda')), 1),
          _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t('label.selecciona.fecha')), 1),
          _createVNode(_component_NavPill, {
            items: _ctx.fechas,
            modelValue: _ctx.fechaSeleccionada,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.fechaSeleccionada) = $event)),
            onChange: _ctx.onChangeFechaCronograma
          }, null, 8, ["items", "modelValue", "onChange"])
        ]),
        _createElementVNode("ul", _hoisted_15, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detallesAgenda, (item, i) => {
            return (_openBlock(), _createElementBlock("li", {
              onClick: ($event: any) => (_ctx.mostrarDetalleAgenda(item)),
              key: i,
              class: "hover:bg-gradient-to-r from-gray-200 to-gray-50 cursor-pointer"
            }, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", {
                  class: "h-16 w-16 rounded-lg shadow-xl flex items-center justify-center border",
                  style: _normalizeStyle({ borderColor: item.colorEstado, color: item.colorEstado })
                }, [
                  _createVNode(_component_font_awesome_icon, {
                    icon: _ctx.getIcono(item),
                    class: "text-2xl"
                  }, null, 8, ["icon"])
                ], 4),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, _toDisplayString(item.cronograma.horaDesde), 1),
                  _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.detalleAgendaCita(item)), 1),
                  _createElementVNode("div", {
                    class: "text-xs",
                    style: _normalizeStyle({ color: item.colorEstado })
                  }, _toDisplayString(_ctx.descripcionEstadoCompleta(item)), 5)
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createVNode(_component_font_awesome_icon, {
                    icon: ['far', 'fa-eye'],
                    class: "text-2xl mr-2 text-gray-500"
                  })
                ])
              ])
            ], 8, _hoisted_16))
          }), 128))
        ])
      ])
    ]),
    (_ctx.detalleAgendaVisible)
      ? (_openBlock(), _createBlock(_component_DetalleAgendaView, {
          key: 0,
          closeFunction: _ctx.closeDialogDetalleAgenda,
          acreditado: _ctx.acreditado,
          detalleAgenda: _ctx.detalleAgendaSeleccionada
        }, null, 8, ["closeFunction", "acreditado", "detalleAgenda"]))
      : _createCommentVNode("", true),
    _createVNode(_component_FullScreenLoader, { visible: _ctx.isSubmitting }, null, 8, ["visible"])
  ], 64))
}